import React, { SVGProps } from "react";
export default function SupDEX(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.08903 3H12.589C14.522 3 16.089 4.567 16.089 6.5V13.0785L14.7274 11.8819L14.0673 12.633L16.5674 14.8302L18.7646 12.3301L18.0135 11.6699L17.089 12.7218V6.5C17.089 4.01472 15.0743 2 12.589 2H4.08903V3Z"
        fill="currentColor"
      />
      <path
        d="M16.089 17L7.58903 17C5.65603 17 4.08903 15.433 4.08903 13.5L4.08903 7.20711L5.23547 8.35355L5.94258 7.64645L3.58903 5.29289L1.23547 7.64645L1.94258 8.35355L3.08903 7.20711L3.08903 13.5C3.08903 15.9853 5.10375 18 7.58903 18L16.089 18V17Z"
        fill="currentColor"
      />
    </svg>
  );
}
